import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import moment from 'moment-timezone'

import '../../../css/news-article.css'

class TrainingPreviewItem extends React.PureComponent {
	render() {
		const { translations, item } = this.props

		return (
			<Link to={`/`} className='news-article-preview'>
				<div className='event-listing-item--content'>
					<h3>{item.title}</h3>
					{/* <div className='article-date'>
						<span>{translations.sections.training_listing.start_date_label}:</span>
						<span className='start-date'>
							{moment
								.utc(item.date_of)
								.local()
								.format('MMM DD, YYYY')}
						</span>
					</div> */}
				</div>
				{/* <span className='icon-keyboard_arrow_right' /> */}
			</Link>
		)
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations,
	}
}

export default connect(mapStateToProps)(TrainingPreviewItem)



// WEBPACK FOOTER //
// ./src/components/home/training/TrainingPreviewItem.js